export default "__VITE_ASSET__iVckGXcp__"